var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Awards.less');

var CommonHonoredList = require('front/components/CommonHonoredList/CommonHonoredList');

require('dotdotdot');

module.exports = Section.extend({

    el: '.Awards',

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonHonoredList': {selector: '.CommonHonoredList', viewConstructor: CommonHonoredList}
    },

    events: {
    },

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'updateEllipsis');

        Section.prototype.initialize.call(this, options);

        this.$('.Awards-itemText p').dotdotdot({
            watch: true
        });

        window.app.vent.on('fonts-loaded', this.updateEllipsis);
    },


    updateEllipsis: function () {
        this.$('.Awards-itemText p').trigger('update.dot');
    },


    activate: function () {

        return Section.prototype.activate.call(this);
    },


    deactivate: function (params) {

        return Section.prototype.deactivate.call(this, params);
    },


    render: function () {
        var result = Section.prototype.render.call(this);

        return result;
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Awards/Awards.js
// module id = 246
// module chunks = 0